<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>
<style lang="scss">
  @import './styles/index.scss'; /** 全局自定义的css样式*/
</style>





// WEBPACK FOOTER //
// App.vue?ed182e8a